import axios from "axios";

export const listInstrument = data =>
    axios("satinfo/instruments/", { params: data });
export const getInstrument = data => axios(`satinfo/instruments/${data.id}/`);

export const listInstrumentType = data =>
    axios("satinfo/classifications/", { params: data });
